import { FC } from "react";
import orderOptimizerHelper from "../../../../../../common/order-optimizer.helper";
import LinkButtonComponent from "../../../../../../../../common/components/button/link/link-button.component";
import dateService from "../../../../../../../../common/utils/date/date.service";
import orderRoutesHelper from "../../../../../../../order/common/routes/order-routes.helper";
import orderOptimizerTaxiDetailsHiddenDetailsOrdersOrderSummaryHelper from "./order-optimizer-taxi-details-hidden-details-center-tables-orders-order-summary.helper";
import { OrderOptimizerTaxiDetailsItemOrders } from "../../../../common/types/order-optimizer-taxi-details-item";
import orderOptimizerTaxiDetailsHelper from "../../../../order-optimizer-taxi-details.helper";

type OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrderSummaryProps =
  {
    order: OrderOptimizerTaxiDetailsItemOrders;
    orderIndex: number;
  };

const OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrderSummaryComponent: FC<
  OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrderSummaryProps
> = (props) => {
  const dotColor = orderOptimizerHelper.getOrderColor(props.orderIndex);
  const currentDate = new Date();
  const startTime = new Date(props.order.startTime);

  const orderIdTitle =
    orderOptimizerTaxiDetailsHiddenDetailsOrdersOrderSummaryHelper.getOrderIdTitle(
      props.order.humanId
    );
  const orderIdLabel =
    orderOptimizerTaxiDetailsHiddenDetailsOrdersOrderSummaryHelper.getOrderIdLabel(
      props.order.humanId
    );

  const timeDifferenceInSeconds = Math.max(
    Math.floor((startTime.getTime() - currentDate.getTime()) / 1000),
    0
  );

  const startTimeString = orderOptimizerTaxiDetailsHelper.getTimeDeltaLabel(
    timeDifferenceInSeconds
  );

  const startUntilTitle =
    orderOptimizerTaxiDetailsHiddenDetailsOrdersOrderSummaryHelper.getStartTimeTitle(
      startTimeString
    );
  const startUntilLabel =
    orderOptimizerTaxiDetailsHiddenDetailsOrdersOrderSummaryHelper.getStartTimeLabel(
      startTimeString
    );

  const startDateTitle = dateService.formatDate(props.order.startTime);
  const startDateLabel = dateService.formatDate(props.order.startTime);

  const planEntryIdTitle =
    orderOptimizerTaxiDetailsHiddenDetailsOrdersOrderSummaryHelper.getPlanEntryIdTitle(
      props.order.planEntryHumanId ?? 0
    );
  const routeIdLabel =
    orderOptimizerTaxiDetailsHiddenDetailsOrdersOrderSummaryHelper.getPlanEntryIdLabel(
      props.order.planEntryHumanId ?? 0
    );

  return (
    <div className="order_summary">
      <div className="order_id">
        <div
          className="dot"
          style={{
            backgroundColor: dotColor,
          }}
        />
        <LinkButtonComponent
          openInNewTab
          to={orderRoutesHelper.getListingOfActiveOrdersRoute({
            internalOrderId: String(props.order.humanId),
          })}
        >
          <div className="text" title={orderIdTitle}>
            {orderIdLabel}
          </div>
        </LinkButtonComponent>
      </div>
      <div title={props.order.cargoCompany}>{props.order.cargoCompany}</div>
      <div title={props.order.billingModel}>{props.order.billingModel}</div>
      <div title={props.order.taxiCorporation}>
        {props.order.taxiCorporation}
      </div>
      <div title={startUntilTitle}>{startUntilLabel}</div>
      <div title={startDateTitle}>{startDateLabel}</div>
      {props.order.driverName && (
        <div className="driver_name" title={props.order.driverName}>
          {props.order.driverName}
        </div>
      )}
      {props.order.fleetPartner && (
        <div title={props.order.fleetPartner}>{props.order.fleetPartner}</div>
      )}
      {props.order.planEntryHumanId && (
        <div title={planEntryIdTitle}>{routeIdLabel}</div>
      )}
    </div>
  );
};

export default OrderOptimizerTaxiDetailsHiddenDetailsCenterTablesOrdersOrderSummaryComponent;
